import Vue from 'vue';
import moment from 'moment';

export default function formatDateNormal(date) {
    if (!date) return date;
    const dateFormat = Vue.t('global.format.date');
    return moment(date).format(`${dateFormat}`);
}
